<template>
  <div class='RegisterProdDesktop'>
    <div class="block">
      <div class="left">
        <input-select
        v-if="Theme.name != 'Modelo 03'"
        :value="SelectedProdEdit.tipo"
        @update:model-value="newValue => ChangeProdEdit({ tipo: newValue })"
        :data="types"
        text="Tipo"
        :cont="{ width: '40%' }"
        :label="{ textAlign: 'left', marginTop: '5px', marginLeft: '3px' }"
        :input="{ width: '100%', padding: '4%', fontSize: '16px', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
        <div class="cont-destaque">
          <input
          :checked="SelectedProdEdit.destaque"
          @change="ChangeProdEdit({ destaque: !SelectedProdEdit.destaque })"
          type="checkbox"
          />
          <div>Destaque</div>
        </div>
      </div>
    </div>
    <div class="block cont">
      <input-info/>
      <input-img/>
    </div>
    <div class="btns">
        <button v-if="!edit" @click="push">Salvar</button>
        <button v-if="edit" @click="update">Atualizar</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputInfo from './InputInfo.vue'
import InputImg from './InputImg.vue'
import InputSelect from './InputSelect'
export default {
  name: 'RegisterProdDesktop',
  components: { InputInfo, InputImg, InputSelect },
  data () {
    return {
      types: [
        { name: 'Simples' },
        { name: 'Variável' }
      ]
    }
  },
  computed: {
    ...mapGetters(['SelectedProdEdit', 'Theme', 'Empresa']),
    edit () {
      return this.SelectedProdEdit.id !== ''
    }
  },
  methods: {
    ...mapActions(['ChangeProdEdit', 'PushProd', 'ClearProdEdit', 'PushMsg', 'VerifyPermission', 'SetModal', '_UpdateProduct']),
    async push () {
      this.SetModal({ 
        component: 'AskAction',
        active: true,
        ask: `Deseja cadastrar o ${this.Empresa.modelo === 'Modelo 03' ? 'imóvel' : 'produto'}?`,
        action: 'PushProd',
        payload: this.SelectedProdEdit
      })
    },
    update () {
      this._UpdateProduct(this.SelectedProdEdit)
        .then(() => {
          this.$router.push('/painel/produtos')
        })
    }
  }
}
</script>

<style scoped>
.RegisterProdDesktop {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.block {
  display: flex;
  padding: 2%;
}

.btns {
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: start;
  padding-left: 1%;
}

.left {
  width: 70%;
  display: flex;
  align-items: center;
}

button {
  border: 0;
  font-size: 16px;
  padding: 1.5%;
  margin: 1%;
  border-radius: 5px;
  background-color: #333333;
  color: #FFFFFF;
  cursor: pointer;
}

.cont-destaque {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2%;
  margin-top: 3%;
}

@media (max-width: 500px) {
  .RegisterProdDesktop {
    display: none;
  }
}
</style>
